import * as React from 'react'

import { ExternalPinSource, ListingType } from '../../types'
import { pinSource } from '../util'
import { Image } from './Pin.styles'

interface IProps {
  clickable: boolean
  selected: boolean
  src?: ExternalPinSource
}

export default function WonderschoolPin(props: IProps) {
  const { clickable, selected, src } = props
  const uuid = selected
    ? '0de88c6d-435b-48ed-b8c2-f4e8c9590c5a'
    : 'e9a44feb-782f-45b6-8bfd-064af7b02d13'

  const source: string | undefined = pinSource(ListingType.INTERNAL, selected, uuid, src)

  return (
    <Image
      clickable={clickable}
      height={selected ? 60 : 40}
      src={source}
      width={selected ? 55 : 35}
    />
  )
}
